<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
    .mb-5
    section
      //- .tab-wrap
        .tab-item(v-for="tab in tabs", @click="tabScroll(tab.offsetTop)") {{ tab.name }}
    .mb-10
    section
      .section-title 主辦單位
      .logo-wrap
        img.logo(src="~assets/thanks/logo-4gamers.png")
        img.logo(src="~assets/thanks/logo-infamous.png")
      .section-title 合作夥伴
      .logo-wrap
        img.logo(src="~assets/thanks/logo-nvidia.png")
        img.logo(src="~assets/thanks/logo-cht.png")
      .section-title 合辦單位
      .logo-wrap
        img.logo(src="~assets/thanks/logo-taipeiDED.png")
        img.logo(src="~assets/thanks/logo-dcipo.png")
        img.logo(src="~assets/thanks/logo-ifin.png")
      .section-title WirForce 推薦處理器
      .logo-wrap
        img.logo(src="~assets/thanks/logo-intel.png")
      .section-title 參與單位
      .logo-wrap
        img.logo(src="~assets/thanks/logo-gigabyte.png")
        img.logo(src="~assets/thanks/logo-asus.png")
        img.logo(src="~assets/thanks/logo-twitch.png")
        img.logo(src="~assets/thanks/logo-cygames.png")
        img.logo(src="~assets/thanks/logo-msi.png")
        img.logo(src="~assets/thanks/logo-teamgroup.png")
        img.logo(src="~assets/thanks/logo-agon.png")
        img.logo(src="~assets/thanks/logo-hyperx.png")
        img.logo(src="~assets/thanks/logo-double.png")
        img.logo(src="~assets/thanks/logo-omen.png")
        img.logo(src="~assets/thanks/logo-preoator.png")
        img.logo(src="~assets/thanks/logo-patriot.png")
        img.logo(src="~assets/thanks/logo-xpg.png")
        img.logo(src="~assets/thanks/logo-ubisoft.png")
        img.logo(src="~assets/thanks/logo-magic.png")
        img.logo(src="~assets/thanks/logo-plantronics.png")
        img.logo(src="~assets/thanks/logo-tca.png")
      .section-title 大會推薦電競椅品牌
      .logo-wrap
        img.logo(src="~assets/thanks/logo-sharkoon.png")
      .section-title 協力夥伴
      .logo-wrap
        img.logo(src="~assets/thanks/logo-asc.png")
        img.logo(src="~assets/thanks/logo-met.png")
      .section-title 媒體合作單位
      .logo-wrap
        img.logo(src="~assets/thanks/logo-yahoo.png")
        img.logo(src="~assets/thanks/logo-uacg.png")
        img.logo(src="~assets/thanks/logo-piko.png")
        img.logo(src="~assets/thanks/logo-xfastest.png")
        img.logo(src="~assets/thanks/logo-aottergirl.png")
        img.logo(src="~assets/thanks/logo-pnn.png")
    .mb-40
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'thanks',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.logo-wrap
  margin-bottom: 64px
  .logo
    margin: 8px
</style>



// WEBPACK FOOTER //
// thanks.vue?6d26dd6b